module.exports = __webpack_public_path__ + "static/img/04943165.94bb26ba.png";